export default __webpack_public_path__ + "static/media/website-icon-blue.53bf6cf6.svg";